<template lang="pug">
v-dialog(v-if="showDialog" v-model="showDialog" max-width=568 content-class="round-2xl" persistent)
  v-card(rounded="lg")
    v-card-title.px-4
      v-spacer
      .text-xl.font-bold.ml-10 {{ $t('remove_member') }}
      v-spacer
      v-btn(icon @click="showDialog = false")
        v-icon mdi-close
    v-divider.mb-6

    .px-6
      .text-lg.font-medium.mb-8 {{ $t('remove_member_confirmation_1') }}
      .text-md.mb-2 {{ $t('remove_member_confirmation_2') }}
      .text-md.mb-16 {{ $t('click_confirm_to_proceed') }}
    v-divider
    
    v-card-actions.px-6.py-3
      v-spacer
      v-btn.button-md.neutral500--text(@click="showDialog = false" text) {{ $t('back') }}
      v-btn.button-md.white--text(@click="deleteMembers" :loading="isLoading" color="danger500" depressed) {{ $t('confirm') }}
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  props: ['open', 'members'],
  data: () => ({
    isLoading: false
  }),
  computed: {
    ...mapGetters({
      company: 'getCompany'
    }),
    showDialog: {
      get () {
        return this.open
      },
      set (newValue) {
        this.$emit('update:open', newValue)
      }
    }
  },
  methods: {
    ...mapActions([
      'showMessage'
    ]),
    async deleteMembers () {
      this.isLoading = true
      let hasError = false
      await this.asyncForEach(this.members, async (member) => {
        try {
          this.isLoading = true
          await this.axios.delete(`/members/${member.id}/`)
        } catch(err) {
          hasError = true
        }
      })
      if (hasError) {
        this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        return
      }
      this.showMessage(['success', this.$t('success_message.member_remove_successfully')])
      this.isLoading = false
      this.showDialog = false
      this.$emit('deleted')
    }
  }
}
</script>